/** Tokens do manual da marca (/branding) — cores, fontes e gradiente institucional. */

export const BRAND_MANUAL = {
  light: '#F2F2F2',
  dark: '#1E1E1E',
  bluePrimary: '#3C7CF8',
  blueMid: '#78A5FA',
  bluePale: '#AECCF6',
  blueSoft: '#6CAFFF',
  white: '#FFFFFF'
} as const;

export const FONT_STACK_HEADING = `'Nohemi', 'Poppins', sans-serif`;
export const FONT_STACK_BODY = `'Poppins', sans-serif`;

/** Escala primária MUI (índice `5` = `primary.main`) — modo claro; usada pelo preset `theme8` (/branding). */
export const SWIFT_PRIMARY_LIGHT: readonly string[] = [
  '#EDF4FF',
  '#DCEBFC',
  '#C8DDFA',
  BRAND_MANUAL.bluePale,
  BRAND_MANUAL.blueMid,
  BRAND_MANUAL.bluePrimary,
  '#2F67DC',
  '#2653B8',
  '#1E4294',
  '#173472'
];

/** Escala primária — modo escuro (main mais legível sobre fundos escuros). */
export const SWIFT_PRIMARY_DARK: readonly string[] = [
  '#121C2E',
  '#182542',
  '#1F3768',
  '#2F56B8',
  BRAND_MANUAL.bluePrimary,
  BRAND_MANUAL.blueSoft,
  BRAND_MANUAL.blueMid,
  '#93B9FC',
  BRAND_MANUAL.bluePale,
  '#DDE9FD'
];

export const BRAND_GRADIENT_STOPS: readonly (readonly [string, string])[] = [
  [BRAND_MANUAL.blueSoft, '0%'],
  [BRAND_MANUAL.bluePale, '25%'],
  [BRAND_MANUAL.blueMid, '50%'],
  [BRAND_MANUAL.bluePrimary, '75%'],
  [BRAND_MANUAL.light, '100%']
];

export type BrandManualColorRow = {
  hex: string;
  swatch: { background: string };
  rgb: string;
  cmyk: string;
};

/** Ordem e valores idênticos ao manual (paleta principal). */
export const BRAND_MANUAL_CORES: readonly BrandManualColorRow[] = [
  { hex: '#F2F2F2', swatch: { background: '#F2F2F2' }, rgb: 'RGB 242, 242, 242', cmyk: 'CMYK 6, 4, 5, 0' },
  { hex: '#1E1E1E', swatch: { background: '#1E1E1E' }, rgb: 'RGB 30, 30, 30', cmyk: 'CMYK 75, 65, 60, 80' },
  { hex: '#3C7CF8', swatch: { background: '#3C7CF8' }, rgb: 'RGB 60, 124, 248', cmyk: 'CMYK 77, 53, 0, 0' },
  { hex: '#78A5FA', swatch: { background: '#78A5FA' }, rgb: 'RGB 120, 165, 250', cmyk: 'CMYK 56, 31, 0, 0' },
  { hex: '#AECCF6', swatch: { background: '#AECCF6' }, rgb: 'RGB 174, 204, 246', cmyk: 'CMYK 35, 13, 0, 0' },
  { hex: '#6CAFFF', swatch: { background: '#6CAFFF' }, rgb: 'RGB 108, 175, 255', cmyk: 'CMYK 57, 24, 0, 0' }
];
